export const Colors = {
  primary: '#031237',
};

export const Websockets = {
  ReconnectInterval: 10000,
};

export const OptionChain = {
  MaxExpandedExpirations: 4,
};

export const Cashiering = {
  MaxAchRelationships: 3,
};

export const Notifications = {
  DataFeedKey: 'DataFeedGlobal',
  NewsDataFeedKey: 'NewsFeedGlobal',
};

export const OrderValidationTimeoutMS = 500;

export const RequestDebounceMS = {
  getQuote: 250,
};
export const RequestThrottle = {
  getStrike: { maxRequests: 4, requestWindowMs: 1000, duplicateRequestIntervalMs: 10000 },
};
export type TradingEnvironments = 'dev' | 'beta' | 'production' | 'local';
export const TradingEnvironment: Record<TradingEnvironments, TradingEnvironments> = {
  dev: 'dev',
  beta: 'beta',
  production: 'production',
  local: 'local',
};

export const LocalStorageKey = {
  enableRedux: 'enableRedux',
};

export const Session = {
  inactivityTimeout: 1000 * 60 * 60 * 2,
};

// These symbols can be traded before 3:15pm CST or 4:15pm CST without daylight saving.
// And for half days can be traded before 12:15pm CST or 1:15pm CST without daylight saving.
export const SYMBOLS_THAT_CAN_TRADED_AFTER_MARKET_CLOSE = [
  '$AKSC',
  '$AMDC',
  '$ARMD',
  '$AUM',
  '$AUX',
  '$AVSPY',
  '$AXLC',
  '$BACD',
  '$BJE',
  '$BKX',
  '$BPX',
  '$BRB',
  '$BSF',
  '$BSK',
  '$BSZ',
  '$BTK',
  '$BVZ',
  '$BYT',
  '$BZJ',
  '$CDD',
  '$CHXN',
  '$CITD',
  '$CMR',
  '$CRX',
  '$CYC',
  '$DFX',
  '$DIVD',
  '$DJX',
  '$DMA',
  '$DRG',
  '$DTX',
  '$DUX',
  '$DVS',
  '$DXL',
  '$EAFEQ',
  '$EEMIQ',
  '$EPX',
  '$EUI',
  '$EUR',
  '$EUU',
  '$EXQ',
  '$FUM',
  '$FVX',
  '$GBP',
  '$GESPY',
  '$GOOSY',
  '$GOX',
  '$GSSD',
  '$GVZ',
  '$HGX',
  '$HHO',
  '$HOVC',
  '$HSX',
  '$HUI',
  '$HUNC',
  '$HVY',
  '$IBMSY',
  '$IIX',
  '$INTSY',
  '$IRX',
  '$IVSPY',
  '$IXZ',
  '$JBV',
  '$JLO',
  '$JPMD',
  '$JPN',
  '$JVSPY',
  '$KBK',
  '$LVSPY',
  '$MBID',
  '$MFX',
  '$MID',
  '$MNX',
  '$MRKSY',
  '$MSH',
  '$MSTD',
  '$MVR',
  '$MXEA',
  '$MXEF',
  '$NBI',
  '$NDO',
  '$NDX',
  '$NVSPY',
  '$NXTQ',
  '$NZD',
  '$OEX',
  '$OOG',
  '$OSX',
  '$OVX',
  '$PMID',
  '$PMP',
  '$POW',
  '$PZO',
  '$QGRI',
  '$QNET',
  '$RMN',
  '$RMNG',
  '$RND',
  '$RUF',
  '$RUI',
  '$RUT',
  '$RUTMINI',
  '$RVX',
  '$SCP',
  '$SFC',
  '$SFDC',
  '$SIN',
  '$SKA',
  '$SLJ',
  '$SML',
  '$SOX',
  '$SPX',
  '$SPXPM',
  '$SVO',
  '$THCC',
  '$TNX',
  '$TNY',
  '$TYX',
  '$UKX',
  '$UTY',
  '$UVSPY',
  '$VIX',
  '$VXEEM',
  '$VXEWZ',
  '$WMTSY',
  '$WMX',
  '$WVSPY',
  '$XAL',
  '$XAU',
  '$XBD',
  '$XDA',
  '$XDB',
  '$XDC',
  '$XDE',
  '$XDM',
  '$XDN',
  '$XDS',
  '$XDV',
  '$XDZ',
  '$XEH',
  '$XEO',
  '$XEV',
  '$XNG',
  '$XOI',
  '$XSP',
  '$YUK',
  '$ZZZZ',
  'DBA',
  'DBB',
  'DBC',
  'DBO',
  'DIA',
  'EEM',
  'EFA',
  'IWM',
  'IWN',
  'KRE',
  'MDY',
  'OEF',
  'QQQ',
  'SPY',
  'SVXY',
  'UNG',
  'UUP',
  'UVXY',
  'VIXM',
  'VIXY',
  'VXX',
  'XHB',
  'XLB',
  'XLE',
  'XLF',
  'XLI',
  'XLK',
  'XLP',
  'XLU',
  'XLV',
  'XLY',
  'XME',
  'XRT',
];
